import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { CREATE_TRANSACTION } from "../graphql/createTransaction.mutate";

const log: any = LoggerModule?.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICreateTransactionMethods extends IPluginMethodMap {
  createTransaction(args: any): Promise<any>;
}

export class CreateTransactionService implements IAgentPlugin {
  readonly methods: ICreateTransactionMethods;

  constructor() {
    this.methods = {
      createTransaction: this.createTransaction.bind(this),
    };
  }

  async createTransaction(args: any) {
    console.log("cybersourceCardCheck args:", args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    if (!client) {
      throw new Error("GraphQL client not found");
    }

    const input = args?.data || {};
    const amount = Number(input?.amount || input?.price || 0);

    if (!amount || Number.isNaN(amount)) {
      throw new Error("Amount is required for card check");
    }

    const data: any = {
      sessionId: input?.sessionId,
      transientToken: input?.transientToken,
      amount: amount,
      firstName: input?.firstName,
      lastName: input?.lastName,
      address1: input?.address1,
      locality: input?.locality,
      administrativeArea: input?.administrativeArea,
      postalCode: input?.postalCode,
      country: String(input?.country || "").toUpperCase(),
      email: input?.email,
      phoneNumber: input?.phoneNumber,
    };
    // TEMP: Platform Fee disabled until backend deployment
    if (input?.platformFee !== undefined && input?.platformFee !== null) {
      data.platformFee = input.platformFee;
    }
    try {
      const res = await client.mutate({
        mutation: CREATE_TRANSACTION,
        variables: { data },
        fetchPolicy: "no-cache",
      });

      return {
        res: res?.data?.cybersourceCardCheck,
        url: null,
      };
    } catch (err: any) {
      console.log("cybersourceCardCheck error", err);

      const displayMessage =
        err?.graphQLErrors?.find((item: any) => item?.extensions)?.extensions
          ?.display_message ||
        err?.message ||
        "CyberSource card check failed";

      throw new Error(displayMessage);
    }
  }
}
